import React from "react";
import { Box } from "@mui/material";
import { COLORS } from "../shared/styles";
import { CheckTickIcon } from "./icons";

function PreferenceCheckbox({ checked, onChange, label }) {
  return (
    <Box
      component="button"
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        p: 0,
        borderRadius: "8px",
        border: `1px solid ${checked ? COLORS.primary : COLORS.border}`,
        background: COLORS.white,
        cursor: "pointer",
        boxSizing: "border-box",
        boxShadow: checked ? "0 1px 2px 0 rgba(20, 141, 253, 0.1)" : "none",
      }}
    >
      {checked ? <CheckTickIcon /> : null}
    </Box>
  );
}

export default PreferenceCheckbox;
